var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcTrashRegular = function SvgIcTrashRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.3 9.3c-.4 0-.8.3-.8.7-.2 2-.6 6.7-.8 9-.1 1-.6 1.5-1.6 1.5H8.3c-.9 0-1.5-.5-1.6-1.5-.3-2.4-.7-7.5-.8-9 0-.4-.4-.7-.8-.7s-.7.4-.7.8c.1 1.5.6 6.7.8 9.1.2 1.7 1.3 2.8 3 2.8h7.9c1.7 0 2.9-1.1 3.1-2.8.3-2.3.7-7.1.8-9.1.1-.5-.2-.8-.7-.8M20.7 5.5h-3.3c-.4 0-.8-.3-.9-.7l-.3-1.3c-.2-.9-1-1.5-2-1.5h-4.1c-.9 0-1.7.6-2 1.6l-.2 1.2c-.1.4-.5.7-.9.7H3.8c-.5 0-.8.3-.8.7s.3.8.8.8h17c.4 0 .8-.3.8-.8s-.5-.7-.9-.7M9.4 5.1l.2-1.2c.1-.2.3-.4.5-.4h4.2c.2 0 .5.2.5.3L15 5c0 .1.1.3.1.4h-6c.2 0 .2-.2.3-.3"
  })));
};
export default SvgIcTrashRegular;